import MuiTooltip from './MuiTooltip';
export default MuiTooltip;
